module.exports = __webpack_public_path__ + "img/sin.ed839e6a.svg";